/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof CreateAccountRequest
     */
    readonly $schema?: string;
    /**
     * Recaptcha token
     * @type {string}
     * @memberof CreateAccountRequest
     */
    recaptchaToken: string;
    /**
     * Username
     * @type {string}
     * @memberof CreateAccountRequest
     */
    username: string;
}

/**
 * Check if a given object implements the CreateAccountRequest interface.
 */
export function instanceOfCreateAccountRequest(value: object): value is CreateAccountRequest {
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    return true;
}

export function CreateAccountRequestFromJSON(json: any): CreateAccountRequest {
    return CreateAccountRequestFromJSONTyped(json, false);
}

export function CreateAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'recaptchaToken': json['recaptcha_token'],
        'username': json['username'],
    };
}

export function CreateAccountRequestToJSON(json: any): CreateAccountRequest {
    return CreateAccountRequestToJSONTyped(json, false);
}

export function CreateAccountRequestToJSONTyped(value?: Omit<CreateAccountRequest, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recaptcha_token': value['recaptchaToken'],
        'username': value['username'],
    };
}

